/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

window.shippingCountdownBar = {
  previous: 0,
  current: 0
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js?timestamp=' + Date.now(),
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    cache: false,
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);

        jQuery('.co_saved').html('<span class="co_saved_text">SAVED!</span>');
        setTimeout(function () {
          jQuery('.co_saved').html('')
        }, 5000)
      }
      else {
        ShopifyAPI.onCartUpdate(cart);

      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  }

  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    console.log(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function ($form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js?timestamp=' + Date.now(),
    data: $form.serialize(),
    dataType: 'json',
    cache: false,
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, $form[0]);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  }

  jQuery.ajax(params);
};

ShopifyAPI.addItem = function (variantId, quantity, properties, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js?timestamp=' + Date.now(),
    data: $.param({
      id: variantId,
      quantity: quantity,
      properties: properties
    }),
    dataType: 'json',
    cache: false,
    success: function (line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        ShopifyAPI.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  }

  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  var params = {
    method: 'GET',
    // url: '/cart.js?timestamp=' + Date.now(),
    url: '/cart?view=json&timestamp=' + Date.now(),
    // dataType: 'json',
    cache: false,
    success: function (cart) {
      const div = document.createElement("div");
      div.innerHTML = cart;
      const jsonData = JSON.parse(div.querySelector(".shopify-section").innerText);
      if ((typeof callback) === 'function') {
        callback(jsonData);
      } else {
        ShopifyAPI.onCartUpdate(jsonData);
      }
    }
  }

  jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js?timestamp=' + Date.now(),
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    cache: false,
    success: function (cart) {
      // ..
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  }

  jQuery.ajax(params).complete(function (cart) {
    if ((typeof callback) === 'function') {
      // callback(cart);
      callback();
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

ShopifyAPI.changeItemByKey = function (id, quantity, properties, callback) {
  var data = { id, quantity };
  if (!_.isEmpty(properties)) {
    data.properties = properties;
  }
  var params = {
    type: 'POST',
    url: '/cart/change.js?timestamp=' + Date.now(),
    data: $.param(data),
    dataType: 'json',
    cache: false,
    // success: function (cart) {
    //   // ..
    // },
    // error: function (XMLHttpRequest, textStatus) {
    //   ShopifyAPI.onError(XMLHttpRequest, textStatus);
    // }
  }

  jQuery.ajax(params).complete(function (cart) {
    if ((typeof callback) === 'function') {
      // callback(cart);
      callback();
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  'use strict';

  // Public functions
  var init, loadCart;

  var initialized = false;

  // Private general variables
  var settings, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, validateCart, checkGiftWithPurchase;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      ajaxAddToCartSelector: '.ajax-add-to-cart[data-id]',
      cartCountSelector: '[data-cart-count]',
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true,
      cart: null,
      emptyCartItems: []
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // hide upsell item
    $(document).on('click', '.ajaxcart__product--upsell .ajaxcart__product-close', function (evt) {
      evt.preventDefault();
      try {
        var hiddenItems = JSON.parse(localStorage.getItem('hidden_upsell_items') || '[]');
        hiddenItems.unshift({
          expire: Date.now() + 2 * 60 * 60 * 1000,
          product: $(this).data('product_id')
        });
        localStorage.setItem('hidden_upsell_items', JSON.stringify(_.uniqBy(hiddenItems, 'product')));

        $(this).parents('.ajaxcart__product--upsell').remove();
      } catch (e) {
        console.error(e);
      }
    });

    if (settings.ajaxAddToCartSelector) {
      $(document).on('click', settings.ajaxAddToCartSelector, function (evt) {
        evt.preventDefault();
        var $this = $(this);
        var variantId = $this.data('id') || null;
        var qty = $this.data('qty') || 1;
        var properties = $this.data('properties') || null;

        if (!variantId) {
          return false;
        }

        $body.addClass('adding');

        $addToCart = $this;
        $addToCart.removeClass('is-added').addClass('is-adding');

        // Remove any previous quantity errors
        $('.qty-error').remove();

        ShopifyAPI.addItem(variantId, qty, properties, itemAddedCallback, itemErrorCallback);

        return false;
      });
    }

    // Check cart contents before checkout
    try {
      $(document).on('submit', '#CartContainer form.cart', function (e) {
        e.preventDefault();
        validateCart().finally(function () {
          window.location = '/checkout';
        });
      });
    } catch (error) {
      window.location = '/checkout';
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();

    if (!initialized) loadCart(settings.cart);
  };

  validateCart = function () {
    return new Promise(function (resolve, reject) {
      ShopifyAPI.getCart(async function (cart) {
        await checkGiftWithPurchase(cart);

        var runUpdates = [];

        _.forEach(cart.items, function (cartItem) {
          // Handle personalization upcharge
          if (!!cartItem.personalization_recipe_id) {
            // Add upcharge item
            if (_.isEmpty(cartItem.upcharge_parent_key) && -1 === _.findIndex(cart.items, ['upcharge_parent_key', cartItem.key])) {
              runUpdates.push(new Promise(function (resolve, reject) {
                setTimeout(function () {
                  ShopifyAPI.addItem(
                    42288600056000,// https://swigbyom.myshopify.com/admin/products/7212347949248.json
                    cartItem.quantity,
                    {
                      "_final_sale": "Yes",
                      "_upcharge_parent_key": cartItem.key,
                      "RecipeID": 'uc-' + cartItem.personalization_recipe_id
                    },
                    resolve,
                    reject
                  );
                }, runUpdates.length * 250);
              }));
            }
            // Remove upcharge item
            else if (!!cartItem.upcharge_parent_key && -1 === _.findIndex(cart.items, ['key', cartItem.upcharge_parent_key])) {
              runUpdates.push(new Promise(function (resolve, reject) {
                setTimeout(function () {
                  ShopifyAPI.changeItemByKey(cartItem.key, 0, null, resolve);
                }, runUpdates.length * 250);
              }));
            }
          } else {
            var has_final_sale_property = !!_.find(cartItem.properties, function (property) {
              var [first, ...other] = property;
              return first == '_final_sale';
            });

            // Add _final_sale property
            if (cartItem.is_final_sale && !has_final_sale_property) {
              runUpdates.push(new Promise(function (resolve, reject) {
                var properties = { '_final_sale': 'Yes' };
                _.forEach(cartItem.properties, function (property) {
                  var [first, last, ...other] = property;
                  properties[first] = last;
                });
                setTimeout(function () {
                  ShopifyAPI.changeItemByKey(cartItem.key, cartItem.quantity, properties, resolve);
                }, runUpdates.length * 250);
              }));
            }
          }
        });

        Promise.all(runUpdates).finally(resolve);
      });
    });
  };

  loadCart = function (cart) {
    $body.addClass('drawer--is-loading');
    adjustCartCallback(cart);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).toggleClass('hidden-count', cart.item_count === 0);
    }

    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    var formAddToCart = function (evt) {
      evt.preventDefault();
      var $form = $(this);

      $body.addClass('adding');

      $addToCart = $form.find(settings.addToCartSelector);
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm($form, itemAddedCallback, itemErrorCallback);

      return false;
    }

    $(document).off('submit.ajaxcart', settings.formSelector);
    $(document).on('submit.ajaxcart', settings.formSelector, formAddToCart);
  };

  itemAddedCallback = function (line_item) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    adjustCartCallback();
    $body.removeClass('adding');
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    var skip = false;

    // maybe remove Surprise items from cart
    if (!!cart.items.length && 0 === _.filter(cart.items, 'allow_suprise_upsell').length) {
      _.forEach(cart.items, function (item, index) {
        if ('Surprise' === item.type) {
          skip = true;
          ShopifyAPI.changeItem(index + 1, 0, adjustCartCallback);
          return false;
        }
      });
    }

    // wait for cart to update
    if (false === skip) {
      updateCountPrice(cart);
      buildCart(cart);
    }
  };

  buildCart = function (cart) {
    formOverride();

    // Show empty cart
    if (cart.item_count === 0) {
      var template = Handlebars.compile($("#EmptyCartTemplate").html());
      $cartContainer.html(template({
        emptyCartItems: settings.emptyCartItems
      }));
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      upchargeItems = {},
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      if (!!cartItem.upcharge_parent_key) {
        upchargeItems[cartItem.upcharge_parent_key] = {
          key: cartItem.key,
          price: cartItem.price
        };
      }
    });

    $.each(cart.items, function (index, cartItem) {
      // skip upcharge items
      if (!!cartItem.upcharge_parent_key) {
        return;
      }

      var variant_title = cartItem.variant_title != 'Default Title' ? cartItem.variant_title : false;

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.id,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: cartItem.featured_image,
        name: cartItem.title,
        variation: variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        compareAtPrice: Shopify.formatMoney(cartItem.compare_at_price, settings.moneyFormat),
        isSale: cartItem.compare_at_price > cartItem.price,
        isFinalSale: cartItem.is_final_sale,
        isGWP: cartItem.properties.find(([key, value]) => key === '_gwp_promotion'),
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        vendor: cartItem.vendor
      };

      if (!!upchargeItems[cartItem.key]) {
        item.price = Shopify.formatMoney(cartItem.price + upchargeItems[cartItem.key].price, settings.moneyFormat);
        item.upchargeItemKey = upchargeItems[cartItem.key].key;
      }

      items.push(item);
    });

    // cart upsell items
    var upsellItems = _.get(cart, 'cart_upsell_items', []);

    // filter upsell items in cart
    upsellItems = _.filter(upsellItems, function (item) {
      return -1 === _.findIndex(cart.items, ['product_id', item.product_id])
    });

    // maybe filter hidden upsell items
    try {
      var hiddenItems = JSON.parse(localStorage.getItem('hidden_upsell_items') || '[]');
      hiddenItems = _.map(_.remove(hiddenItems, function (item) {
        return Date.now() <= item.expire;
      }), 'product');

      if (!!hiddenItems.length) {
        upsellItems = _.filter(upsellItems, function (item) {
          return -1 === _.indexOf(hiddenItems, item.product_id)
        });
      }
    } catch (e) {
      console.error(e);
    }

    // show upsell items of the last product added to cart
    var upsellItems_Grouped = _.groupBy(upsellItems, 'cart_item_id');
    var upsellItems_Straws = [];
    _.forEach(_.map(cart.items, 'id'), function (id) {
      if (_.has(upsellItems_Grouped, id) && !!upsellItems_Grouped[id].length) {
        // upsellItems = upsellItems_Grouped[id];
        // upsellItems_Straws = _.filter(upsellItems_Grouped[id], ['type', 'Straws'])
        // upsellItems = _.filter(_.uniqBy(upsellItems_Grouped[id], 'type'), function(item) {
        //   return 'Straws' !== item.type;
        // });
        // upsellItems = _.map(_.concat(upsellItems, upsellItems_Straws), function(item) {
        //   var order = 10;

        //   switch(item.type) {
        //     case 'Surprise':
        //       order = 0;
        //       break;
        //     case 'Straws':
        //       order = 1;
        //       break;
        //     case 'Lid':
        //       order = 2;
        //       break;
        //     case 'Accessory':
        //       order = 3;
        //       break;
        //   }

        //   return {
        //     ...item,
        //     order
        //   }
        // });

        // sort
        upsellItems = _.sortBy(upsellItems_Grouped[id], ['sort_order'])

        return false;
      }
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      upsellItems: upsellItems,
      note: cart.note,
      totalPrice: cart.total_price,
      totalPriceFormatted: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      shippingCountdownBar: {
        enabled: 1 < cart.free_shipping_threshold,
        threshold: cart.free_shipping_threshold,
        cart_total: cart.total_price,
        percentage: parseInt(Math.min(cart.total_price / cart.free_shipping_threshold, 1) * 100),
        message: "YAY! You unlocked FREE US Economy Shipping! 🎉"
      }
    }


    if (100 > data.shippingCountdownBar.percentage) {
      data.shippingCountdownBar.message = "Add $amount to unlock FREE US Economy Shipping!".replace('$amount', Shopify.formatMoney(cart.free_shipping_threshold - cart.total_price, settings.moneyFormat))
    }

    window.shippingCountdownBar = {
      previous: window.shippingCountdownBar.current || 0,
      current: data.shippingCountdownBar.percentage || 0
    }
    if (1 < data.shippingCountdownBar.percentage) {
      data.shippingCountdownBar.percentage = window.shippingCountdownBar.previous || data.shippingCountdownBar.percentage;

      setTimeout(function () {
        var loader = document.querySelector('.ajaxcart__progress_bar .loader-progress');
        if (!!loader) loader.style.width = window.shippingCountdownBar.current + '%';
      }, 100);
    }

    $cartContainer.html(template(data));

    cartCallback(cart);
  };

  cartCallback = function (cart) {
    $body.removeClass('drawer--is-loading');

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

    $(window).trigger('ajaxCart.afterCartLoad', [cart, initialized]);

    initialized = true;
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-del', function (event) {
      var $el = $(this),
        $row = $el.parents('.ajaxcart__row'),
        $qtySelector = $('.ajaxcart__qty-num', $row),
        key = $row.data('key'),
        upchargeKey = $row.data('upcharge-key');

      if (!!key && !!upchargeKey) {
        ShopifyAPI.changeItemByKey(upchargeKey, 0, null, function () {
          ShopifyAPI.changeItemByKey(key, 0, null, adjustCartCallback);
        });
      } else if (!!key) {
        ShopifyAPI.changeItemByKey(key, 0, null, adjustCartCallback);
      } else {
        $qtySelector.val(0);
      }
    });

    $body.on('click', '.ajaxcart__qty-adjust', function (event) {
      var $el = $(this),
        $row = $el.parents('.ajaxcart__row'),
        $qtySelector = $('.ajaxcart__qty-num', $row),
        key = $row.data('key'),
        upchargeKey = $row.data('upcharge-key'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
      }

      qty = Math.max(0, qty);

      if (!!key && !!upchargeKey) {
        ShopifyAPI.changeItemByKey(upchargeKey, qty, null, function () {
          ShopifyAPI.changeItemByKey(key, qty, null, adjustCartCallback);
        });
      } else if (!!key) {
        ShopifyAPI.changeItemByKey(key, qty, null, adjustCartCallback);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function (event) {
      var $el = $(this),
        $row = $el.parents('.ajaxcart__row'),
        key = $row.data('key'),
        upchargeKey = $row.data('upcharge-key'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      // If it has a data-line, update the cart
      if (!!key && !!upchargeKey) {
        ShopifyAPI.changeItemByKey(upchargeKey, qty, null, function () {
          ShopifyAPI.changeItemByKey(key, qty, null, adjustCartCallback);
        });
      } else if (!!key) {
        ShopifyAPI.changeItemByKey(key, qty, null, adjustCartCallback);
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    var timeoutId;
    // Save note anytime it's changed
    $body.on('change keyup paste', 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }

      //clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        // Runs 1 second (1000 ms) after the last change
        ShopifyAPI.updateCartNote(newNote, function (cart) { });
      }, 1500);

      // Update the cart note in case they don't click update/checkout

    });
  };

  adjustCartCallback = function (cart) {
    if (typeof cart == 'object') {
      cartUpdateCallback(cart);
      return;
    }

    validateCart().finally(function () {
      ShopifyAPI.getCart(cartUpdateCallback);
    });
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function (event) {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  checkGiftWithPurchase = function (cart) {
    const validatePromotion = (promotion, cart) => {
      // Validate cart conditions for GWP promotion
      let matchingItems = _.filter(cart.items, item => !item?.gwp_promotion);
      if (promotion.collections.length > 0 || promotion.products.length > 0) {
        matchingItems = _.filter(matchingItems, item => (!_.isEmpty(_.intersection(promotion.collections, item.collections)) || promotion.products.includes(item.handle)));
      }

      let qualifiesForPromotion = false;
      qualifiesForPromotion = !!matchingItems.length;

      if (promotion.minimum_quantity_of_items > 0) {
        qualifiesForPromotion = qualifiesForPromotion && _.reduce(matchingItems, (totalQty, item) => item.quantity + totalQty, 0) >= promotion.minimum_quantity_of_items;
      }

      if (promotion.minimum_purchase_amount > 0) {
        qualifiesForPromotion = qualifiesForPromotion && _.reduce(matchingItems, (totalPrice, item) => item.final_line_price + totalPrice, 0) >= promotion.minimum_purchase_amount;
      }

      return qualifiesForPromotion;
    }

    return new Promise((resolve, reject) => {
      try {
        let promises = [];

        // Validate GWP
        cart.items?.forEach(item => {
          if (!!item.gwp_promotion) {
            let promotion = _.find(window?.gwp_promotions, {'promotion_id': item.gwp_promotion, 'free_product': item.id});
            // promotion not found
            if (_.isEmpty(promotion) || !validatePromotion(promotion, cart)) {
              promises.push(new Promise((resolve) => {
                setTimeout(function () {
                  ShopifyAPI.changeItemByKey(item.key, 0, null, resolve)
                }, promises?.length * 200);
              }));
            }
          }
        });

        // Add GWP
        (window?.gwp_promotions || []).forEach(promotion => {
          let gwpCartItem = _.find(cart.items, {'gwp_promotion': promotion.promotion_id, 'id': promotion.free_product});

          if (validatePromotion(promotion, cart) && !gwpCartItem) {
            promises.push(new Promise((resolve) => {
              setTimeout(function () {
                ShopifyAPI.addItem(promotion.free_product, 1, {'_gwp_promotion': promotion.promotion_id}, resolve)
              }, promises?.length * 200);
            }));
          }
        });

        if (!!promises.length) {
          return Promise.all(promises).then(validateCart).finally(resolve);
        }

        resolve();
      } catch (e) {
        console.error(e);
        resolve();
      }
    });
  }

  return module;
}(ajaxCart || {}, jQuery));
